import {action, makeObservable, observable} from 'mobx';
import {showDefaultError, showError, showValidationError, showWarning} from '../../helpers/alerts';
import {api} from '../../ApiFacade';
import {showLoaderAsync} from '../../helpers/loaders';
import {projectDashboardLink} from '../../routing/AppRoutes';
import {mainState} from '../../AppMainState';
import {MusculaSubscritpionPlan} from '../../swagger';
import {redirectTo} from '../../routing/browserHistory';

export class CreateProjectState {
    @observable
    name: string = '';


    constructor() {
        makeObservable(this);
    }

    createProject() {
        if (mainState.currentUser?.musculaSubscritpionPlan === MusculaSubscritpionPlan.MusculaBasic && mainState.projects.length >= 1) {
            showWarning('Limit reached', 'Please upgrade your subscription to create new projects');
            return;
        }

        if (!this.name) {
            showWarning('Error', 'Please provide project name');
            return;
        }


        showLoaderAsync(api().projects.apiProjectsNewPost({
            projectCreateRequest: {
                name: this.name,
            }
        }).then((res) => {
            mainState.reloadProjects();
            redirectTo(projectDashboardLink(res.content?.id ?? ''));
        }).catch(async (err) => {
            if (err.status === 400) {
                const errors = (await err.json()).errors;
                if (errors?.length > 0) {
                    showError('Cannot save this', errors.join('<br/>'), err);
                } else {
                    showValidationError();
                }

            } else {
                showDefaultError(err);
            }
        }));
    }

    @action
    setProjectName(value: string) {
        this.name = value;
    }
}
